export interface SearchResultV2 {
  total: number;
  products: SearchProduct[];
}

export interface SearchProduct {
  brandId: string;
  productId: string;
  title?: string;
  description?: string;
  attributes?: { [key: string]: string[] };
  media?: SearchProductMedia[];
  prices?: SearchProductPrice[];
  masterProduct?: SearchProduct;
  labels?: SearchProductLabel[];
  metaData?: { [key: string]: string | boolean | number };
}

export enum SearchProductMetaData {
  EarliestAvailableDate = 'earliestAvailableDate',
  IsNewProduct = 'isNewProduct',
  IsAvailable = 'isAvailable',
  Popularity = 'popularity',
}

export interface SearchProductMedia {
  id: string;
  type: 'image' | '360' | 'video';
  direction: 'horizontal';
  src: SearchProductMediaSource[];
}

export interface SearchProductMediaSource {
  type: string;
  url: string;
}

export interface SearchProductPrice {
  rrp?: SearchProductPriceRange;
  wsp?: SearchProductPriceRange;
  wspd?: SearchProductPriceRange;
  markup?: SearchProductPriceRange;
  validityPeriod?: SearchProductPriceValidityRange;
  discountPercentage?: number;
}

export interface SearchProductPriceRange {
  currency?: string;
  min?: number;
  max?: number;
}

export interface SearchProductPriceValidityRange {
  startDate?: string;
  endDate?: string;
}

export interface SearchProductLabel {
  name: string;
  labelType: SearchProductLabelType;
  data?: { [key: string]: string };
}

export enum SearchProductLabelType {
  Badge = 'Badge',
  Icon = 'Icon',
  Frame = 'Frame',
}
